// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.reset-pass-confirm-cont h5[data-v-f31247a4] {\n  line-height: 1.7rem;\n  font-size: 1.35rem;\n}\n.reset-pass-confirm-cont p[data-v-f31247a4] {\n  line-height: 1.7rem;\n  font-size: 1.05rem !important;\n  color: var(--bluey-grey);\n}\n.reset-pass-confirm-cont p span[data-v-f31247a4] {\n  color: var(--sea);\n  font-weight: 600;\n}\n.reset-pass-confirm-cont p span[data-v-f31247a4]:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
